export const TIPOS_MATRIZ = [
  {
    value: 1,
    label: "Base",
    color: "geekblue",
    descripcion: "Se usará principalmente para componer a otras matrices",
  },
  {
    value: 2,
    label: "Final",
    color: "purple",
    descripcion: "Matriz para usarse directamente en un presupuesto",
  },
];

export const tipoMatrizInfo = (tipoMatriz) =>
  TIPOS_MATRIZ.find((value) => value.value === tipoMatriz);
